import { useForm } from 'react-hook-form';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';
import { useModal } from 'store/modal';
import { useTranslation } from 'react-i18next';
import { FC, useEffect, useMemo, useRef } from 'react';
import { IInputs as IEmployee } from 'routes/client/structure/employees/components/types';
import { IInputsRejectLeave } from 'routes/client/leaves/components/EmployeeRejectLeave';
import { IInputsRejectLeaveEmployee } from 'routes/client/structure/components/EmployeeRejectLeave';

export type HandleEmployeeSignOptions = {
  docId: string;
  // TODO: Add correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: IInputs | IEmployee | IInputsRejectLeave | IInputsRejectLeaveEmployee | any;
  // TODO: Add correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  methodsProp?: any;
  extraAction?: boolean;
  extraActionCB?: () => void;
};

export type HandleEmployeeSign = (options: HandleEmployeeSignOptions) => Promise<void>;

interface IPropsCodeForm {
  handleEmployeeSign?: HandleEmployeeSign;
  docId: string;
  extraAction?: boolean;
  extraActionCB?: () => void;
  setExitInterviewRef?: (toggle: boolean) => void;
  btnLabelOverride?: string;
  primaryActionBtnType?: 'primary' | 'danger';
}

export interface IInputs {
  code?: string;
  exit_interview_opened?: boolean;
}

// Employee code form
const CodeForm: FC<IPropsCodeForm> = ({
  // eslint-disable-next-line @typescript-eslint/no-shadow
  handleEmployeeSign,
  docId,
  extraAction,
  extraActionCB,
  setExitInterviewRef,
  btnLabelOverride,
  primaryActionBtnType,
}: IPropsCodeForm) => {
  const methods = useForm<IInputs>();
  const { hideModal } = useModal();
  const { t } = useTranslation();
  const codeRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    codeRef?.current?.focus();
  }, []);

  const formSubmit = useMemo(
    () => async (data: IInputs | IEmployee) => {
      if (handleEmployeeSign) {
        await handleEmployeeSign({ docId, data, methodsProp: methods, extraAction, extraActionCB });
      }
    },
    [docId, extraAction, extraActionCB, handleEmployeeSign, methods]
  );

  return (
    <>
      <p>{extraAction ? t('documents.table.signWithCodeMsgAndExitForm') : t('documents.table.signWithCodeMsg')}</p>
      <Form
        methods={methods}
        onSubmit={formSubmit}
        btnLabel={btnLabelOverride || (extraAction ? t('documents.table.signOnly') : t('documents.table.sign'))}
        primaryActionBtnType={primaryActionBtnType}
        extraActionLabel={extraAction ? t('documents.table.signAndExitInterview') : undefined}
        onCancel={() => hideModal()}
        setExitInterviewRef={setExitInterviewRef}
        extraAction={extraAction}
      >
        <FormGroup
          controlId="formGroupCode"
          type="tel"
          name="code"
          setRef={ref => {
            codeRef.current = ref;
          }}
          placeholder="******"
          autoComplete="off"
          isRequired
          isVerificationCode
        />
      </Form>
    </>
  );
};

export default CodeForm;
